import { render, staticRenderFns } from "./prolist.vue?vue&type=template&id=8c5f32b6&scoped=true"
import script from "./prolist.vue?vue&type=script&lang=js"
export * from "./prolist.vue?vue&type=script&lang=js"
import style0 from "./prolist.vue?vue&type=style&index=0&id=8c5f32b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5f32b6",
  null
  
)

export default component.exports